import { createSelector } from 'reselect';
import { selectCurrentCompanyFirstFiscalMonth } from 'modules/turnoverPage/selectors';
import {
  mapDashboardDataToChartView,
  mapDashboardDataToCumulLastDayAnnual,
} from 'helpers/chartDataMappers';
import { formatToTabItemsStructure } from 'helpers/treasury';
import { selectUserCurrentCompanyExercice } from '../../loggedUserInfo/selectors';

export const selectTreasuryStatus = (state) => state.treasuryPage?.status;

export const selectTreasurySingleAccountStatus = (state) =>
  state.treasuryPage?.singleAccountStatus;

export const selectTreasuryData = (state) =>
  state.treasuryPage?.treasuryData || {};

export const selectTreasuryLastUpdatedDate = (state) =>
  state.treasuryPage?.treasuryData?.lastUpdated ||
  new Date(Date.now()).toISOString();

export const selectTreasuryDataForCharts = createSelector(
  [selectTreasuryData, selectUserCurrentCompanyExercice],
  (treasuryData, currentExercice) =>
    mapDashboardDataToChartView(
      treasuryData.datasets,
      'balance',
      currentExercice
    )
);

export const selectTreasuryDataForYear = createSelector(
  [
    selectCurrentCompanyFirstFiscalMonth,
    selectTreasuryLastUpdatedDate,
    selectTreasuryDataForCharts,
  ],
  (firstMonthName, lastUpdate, treasuryChartData) =>
    mapDashboardDataToCumulLastDayAnnual(
      treasuryChartData,
      firstMonthName,
      true,
      lastUpdate
    )
);

export const selectTreasuryUserAccounts = createSelector(
  [(state) => state.treasuryPage?.accounts],
  (accounts) =>
    accounts ? formatToTabItemsStructure(accounts, 'account', 'balance') : []
);
